import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core';
// eslint-disable-next-line import/no-cycle
import EntityAttribute from 'src/components/EntityInspector/EntityInspectorDialog/EntityCard/EntityAttribute';
import { hexToRgba } from 'src/utils/colors';
import classNames from 'classnames';
const useStyles = makeStyles((theme) => ({
    table: {
        color: theme.palette.text.color,
        borderLeft: `1px solid ${hexToRgba(theme.palette.primary.main, 0.5)}`,
        width: '100%'
    }
}));
function EntityCard({ attributes, primaryKeyValue }) {
    const classes = useStyles();
    return (React.createElement("table", { className: classNames(classes.table, 'entity-table') },
        React.createElement("tbody", null, attributes.map((attr) => (React.createElement(EntityAttribute, { key: attr.Name, attr: attr, primaryKeyValue: primaryKeyValue }))))));
}
export default memo(EntityCard);
